import type {
  AxiosRequestConfig,
  DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import { webviewHttpClient } from '@/app/[locale]/(order)/components/auth/webview-http-client';

export interface ChatbotInteractedParams {
  store_id: number;
}

export type ChatbotInteractedResponse = Record<string, any>;

export const chatbotInteractedFn = async (
  params: ChatbotInteractedParams,
  config: AxiosRequestConfig = {}
): Promise<ChatbotInteractedResponse> => {
  const response = await webviewHttpClient.post<ChatbotInteractedResponse>(
    apiRoutes.ahafood.store.chatbot_interacted,
    params,
    {
      ...config,
      headers: {
        ...(config.headers ?? {}),
      },
    }
  );
  return response?.data;
};

export const useChatbotInteracted = (
  options?: UseMutationOptions<
    ChatbotInteractedResponse,
    DefaultQueryError,
    ChatbotInteractedParams
  >
) => {
  return useMutation<
    ChatbotInteractedResponse,
    DefaultQueryError,
    ChatbotInteractedParams
  >({
    mutationFn: chatbotInteractedFn,
    ...options,
  });
};
